import { Main } from 'ui/components/4-habitats/Main/Main';
import { ModuleFeature } from 'features/Modules/DynamicModule/DynamicModuleFeature';
import { Article } from 'ui/components/4-habitats/Article/Article';
import { Footer } from 'ui/components/4-habitats/Footer/Footer';
import { newsMapper, footerMapper } from 'helpers/mappers';
import { usePageContext } from 'application/contexts/PageContext';
import { useLocaleContext } from 'application/contexts/LocaleContext';
import { useDictionaryContext } from 'application/contexts/DictionaryContext';
import { useSiteContext } from 'application/contexts/SiteContext';

export const NewsPageFeature: React.FC<Content.NewsPage> = (newsPage) => {
	const pageContext = usePageContext();
	const siteContext = useSiteContext();
	const dictionary = useDictionaryContext();
	const footerArgs = footerMapper(pageContext.footer, siteContext.settings.globalTheme?.setTheme, dictionary);
	const { pageSections } = newsPage.properties ?? {};
	const articleProps = newsMapper(newsPage);
	const locale = useLocaleContext();

	let selectArticleDateStatus = dictionary.getValue('Article.Published');
	if (articleProps.articleDateStatus === 'Updated') {
		selectArticleDateStatus = dictionary.getValue('Article.Updated');
	}

	return (
		<>
			<Main>
				<Article
					{...{
						...articleProps,
						articleDate: locale.formatStringDate(articleProps.articleDate),
						articleDateStatus: selectArticleDateStatus,
					}}
				></Article>

				{pageSections.map((pageSection, index) => (
					<ModuleFeature key={index} contentModule={pageSection} />
				))}
			</Main>

			{footerArgs && <Footer {...footerArgs} />}
		</>
	);
};
